// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".5a49cefb2e02ba58ed5288eac3917f2b.js";
};